import { FontFamily } from './font-family.js';
import { FontSize } from './font-size.js';
import { FontColor } from './font-color.js';
import { FontBackground } from './font-background.js';


export function Font (pEditor)
{
  this.family = new FontFamily(pEditor, this);
  this.size = new FontSize(pEditor, this);
  this.color = new FontColor(pEditor, this);
  this.background = new FontBackground(pEditor, this);

}